export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/969ec58e91615dd8e1c9d6605affb897.jpg"
          alt="Vaciado de pisos en Girona — piso lleno de muebles, cajas y enseres listo para vaciar. Servicio profesional de vaciado de pisos y locales en Girona y comarca por GIROBUIT"
          title="Vaciado de pisos en Girona - GIROBUIT"
          className="w-full h-full object-cover object-top"
          width={1280}
          height={720}
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#330000]/85 via-[#330000]/60 to-[#330000]/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-32 md:py-40">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#ff0000]/20 border border-[#ff0000]/40 text-red-200 text-xs font-600 px-4 py-1.5 rounded-full mb-6" style={{ fontWeight: 600 }}>
            <i className="ri-map-pin-fill text-[#ff0000]"></i>
            Girona · Gironès · Comarca
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-900 text-white leading-tight mb-6" style={{ fontWeight: 900, fontFamily: "'Montserrat', sans-serif" }}>
            <span className="text-[#ff0000]">Vaciado de pisos</span>{" "}
            y locales en Girona
          </h1>

          <p className="text-lg md:text-xl text-red-100 leading-relaxed mb-8 max-w-xl">
            Retiramos todo lo que no necesitas: muebles, electrodomésticos, enseres y residuos. Servicio discreto, rápido y con <strong className="text-white">presupuesto sin compromiso</strong>.
          </p>

          {/* Trust badges */}
          <div className="flex flex-wrap gap-4 mb-10">
            {[
              { icon: "ri-shield-check-fill", text: "Servicio discreto" },
              { icon: "ri-time-fill", text: "Servicio urgente" },
              { icon: "ri-price-tag-3-fill", text: "Presupuesto gratis" },
            ].map((b) => (
              <div key={b.text} className="flex items-center gap-2 text-sm text-red-100">
                <i className={`${b.icon} text-[#ff0000]`}></i>
                <span>{b.text}</span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 w-full">
            <a
              href="tel:+34602365996"
              className="flex items-center justify-center gap-3 bg-[#ff0000] text-white px-8 py-4 rounded-full text-base font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#cc0000] hover:scale-105 w-full sm:w-auto"
              style={{ fontWeight: 700, boxShadow: "0 4px 20px rgba(255,0,0,0.4)" }}
            >
              <i className="ri-phone-fill text-lg"></i>
              Llamar ahora
            </a>
            <a
              href="https://wa.me/34602365996"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-white/15 backdrop-blur-sm border-2 border-white/40 text-white px-8 py-4 rounded-full text-base font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-white/25 hover:scale-105 w-full sm:w-auto"
              style={{ fontWeight: 700 }}
            >
              <i className="ri-whatsapp-line text-lg text-[#25D366]"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 text-xs">
        <span>Descubre más</span>
        <i className="ri-arrow-down-line text-lg animate-bounce"></i>
      </div>
    </section>
  );
}
